module.exports = __webpack_public_path__ + "img/Rectangle 40 (1).2741d3c9.svg";